function Type(x = null) {
    var t = (typeof x);
    return (x === null       ) ? 'null' :
           (t === 'undefined') ? 'null' :
           (Array.isArray(x) ) ? 'array':
           (t === 'boolean'  ) ? 'bool' : t;
}

function keyOf(str) {
    return String(str).replace(/\s+/g, '').toLowerCase();
}

function isKey(k) {
    return (typeof k === 'string' || typeof k === 'number');
}

function isContainer(c) {
    return Array.isArray(c) || (!!c && typeof c === 'object');
}

function injectArgs(expr, ...args) {
    let i = 0;
    let isArr  = (x) => Array.isArray(x);
    let isSlot = (x) => (typeof x === 'string') && /^_+$/g.test(x);
    let getArg = (i) => (i < args.length) ? args[i] : null;
    let inject = (x) => (isArr(x) ) ? x.map(inject) :
                        (x === '_') ? getArg(i++) :
                        (isSlot(x)) ? x.substr(1)
                                    : x;
    return inject(expr);
}

function callbackOf(expr) {
    let t = (typeof expr);
    let params = (name, args) => args.map(a => [name, a]).slice(0, 1);
    return (t === 'function'   ) ? expr :
           (Array.isArray(expr)) ? (...args) => injectArgs(expr, ...args) :
           (t === 'string'     ) ? (...args) => ['AppEvent', expr, ...params(expr, args)]
                                 : (...args) => ['AppEvent', 'CallBack', ...params('CallBack', args)];
}

function actionsOf(action) {
    let noActions = (a) => !Array.isArray(a) || a.length < 1;
    let oneAction = (a) => keyOf(a[0]) !== 'do';
    return noActions(action) ? [] :
           oneAction(action) ? [action]
                             : [].concat(...action.slice(1).map(actionsOf));
}

function combineActions(...actions) {
    let all = actionsOf(['Do', ...actions]);
    return (all.length < 1) ? [] :
           (all.length < 2) ? all[0]
                            : ['Do', ...all];
}

function extractCommands(context, ...sources) {
    let cmds = {};
    sources.map(src => {
        let obj = (typeof src === 'function' ? src(context) : src) || {};
        Object.keys(obj).map(k => {
            let key    = keyOf(k);
            let macro  = key.charAt(0) === '_';
            let name   = key.substr(macro ? 1 : 0);
            let cmd    = obj[k];
            cmd.macro  = macro;
            cmds[name] = cmd;
        });
    });
    return cmds;
}

function setWindowLocationHref(url){
    window.location.href = url;
}

export { Type, keyOf, isKey, isContainer, injectArgs, callbackOf, combineActions, extractCommands, setWindowLocationHref }


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/helpers.js